<template>
  <div>
    <navbar/>
    <div class="relative w-screen flex flex-row flex-no-grow flex-no-shrink overflow-y-hidden z-0 bg-grey-extralight" style="height: calc(100vh - 3rem);">
      <!-- Menu -->
      <mini-menu style="height: inherit;"/>
      <!-- Dymanic Components -->
      <component v-bind:is="selectedMenu" class="flex flex-row w-screen" style="height: inherit;"></component>
    </div>
    <div class="loader">
      <loader/>
    </div>
    <div class="toaster">
      <toaster/>
    </div>
    <NewUpdateAvailableModal />
    <div v-if="isReloaded">
      <PendingQueriesModal v-if="queries.length > 0" @close='closeReloadOverlay'/>
      <BackOnlineModal v-else  @close='closeReloadOverlay'/>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import MiniMenu from '@/components/MiniMenu'
import Loader from '@/components/common/Loader'
import Toaster from '@/components/common/Toaster'
import Chat from '@/components/Chat/ChatMain'
import Appointments from '@/components/Appointments/Appointments'
import OfflineConsults from '@/components/OfflineConsultations/OfflineConsultMain'
import DoctorSchedule from '@/components/DoctorRoster/DoctorSchedule'
import COVID19 from '@/components/COVID-19/COVID19.vue'
import NewUpdateAvailableModal from '@/components/common/modals/NewUpdateAvailable'
import PendingQueriesModal from '@/components/common/modals/PendingQueries'
import BackOnlineModal from '@/components/common/modals/BackOnline'
import {mapGetters} from 'vuex'
import soundAlerts from '@/core/alerts'
import localforage from 'localforage'
import { removeElement } from '../components/common/snackbar/helpers'

export default {
  components: {
    Navbar,
    MiniMenu,
    Loader,
    Toaster,
    Chat,
    Appointments,
    OfflineConsults,
    DoctorSchedule,
    NewUpdateAvailableModal,
    PendingQueriesModal,
    COVID19,
    BackOnlineModal
  },
  data () {
    return {
      isReloaded: true,
      newUserSoundAlerts: null,
      missedSnackbar: null,
      requestSnackbar: null
    }
  },
  computed: {
    ...mapGetters({
      selectedMenu: 'configuration/getActiveMiniMenu',
      queries: 'consultationRequest/getQueries',
      consultRequests: 'consultationRequest/getRequests',
      missedRequests: 'consultationRequest/getMissedRequests',
      othersAcceptedRequests: 'consultationRequest/getOthersAcceptedRequest',
      cancelledRequests: 'consultationRequest/getCancelledRequest',
      role: 'configuration/getRole'
    })
  },
  mounted () {
    try {
      this.mutedAudio()
    } catch (error) {
      console.log(error)
    }
    // check for Navigation Timing API support
    if (window.performance && window.performance.navigation.type === 1) {
      this.isReloaded = true
    } else {
      this.isReloaded = false
    }
  },
  watch: {
    role: {
      immediate: true,
      handler (role) {
        if (role === 'specialistDoctor') {
          this.$store.dispatch('configuration/setActiveMiniMenu', 'Appointments')
        }
      }
    },
    consultRequests: function (newVal, oldVal) {
      let allNewOtherReq = newVal.filter(function (ele) {
        return (ele.status === 'unicasted' || ele.status === 'broadcasted')
      })
      let allOldOtherReq = oldVal.filter(function (ele) {
        return (ele.status === 'unicasted' || ele.status === 'broadcasted')
      })
      if (allNewOtherReq > allOldOtherReq) {
        if ((allNewOtherReq.length >= 1) && allNewOtherReq[allNewOtherReq.length - 1].status === 'unicasted') {
          this.showSnackbar(allNewOtherReq[allNewOtherReq.length - 1])
        } else if ((allNewOtherReq.length > 1) && allNewOtherReq[allNewOtherReq.length - 1].status === 'unicasted') {
          this.showSnackbar(allNewOtherReq[allNewOtherReq.length - 1])
        }
      }
      if (allNewOtherReq.length > 0) {
        // this.clearSetInterval()
        this.browserNotification({body: this.getIncomingRequestText(allNewOtherReq[allNewOtherReq.length - 1]), icon: '/static/images/ekincare_logo.png'})
        this.soundNotification()
      }
      if (allNewOtherReq.length < 1) {
        if (this.requestSnackbar) {
          this.requestSnackbar.close()
        }
        this.clearSetInterval()
      }
    },
    missedRequests: function (newVal, oldVal) {
      if ((newVal > oldVal) && newVal[newVal.length - 1].status !== 'broadcasted') {
        // this.showMissedSnackbar(newVal[0])
        console.log('Missed request')
      } else if (newVal.length < 1) {
        if (this.missedSnackbar) {
          this.missedSnackbar.close()
          this.missedSnackbar = null
        }
      }
    },
    cancelledRequests: function (newVal, oldVal) {
      if ((newVal > oldVal) && newVal[newVal.length - 1].status !== 'broadcasted') {
        this.removeSnackbarWithSameId(newVal[newVal.length - 1].customer_id)
        // this.showCancelledSnackbar(newVal[0])
        console.log('cancelled')
      }
    },
    othersAcceptedRequests: function (newVal, oldVal) {
      if ((newVal > oldVal) && newVal[newVal.length - 1].status !== 'broadcasted') {
        // this.showOtherAcceptedSnackbar(newVal[0])
        console.log('others accepted')
      }
    }
  },
  beforeDestroy () {
    this.clearSetInterval()
    if (this.missedSnackbar) this.missedSnackbar.close(); this.missedSnackbar = null
    if (this.requestSnackbar) this.requestSnackbar.close(); this.requestSnackbar = null
    this.newUserSoundAlerts = null
  },
  methods: {
    mutedAudio: function () {
      // This plays a muted audio when the page loads for the first time to bypass chromes perfomance issues
      let audio = new Audio('/static/sounds/msg_received.ogg')
      audio.muted = true
      audio.play().then().catch(e => {
        console.log(e)
        // this.isReloaded = true
      })
    },
    browserNotification: function (options) {
      // Let's check if the browser supports notifications
      if (!('Notification' in window)) {
        console.log('This browser does not support desktop notification')
      } else if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        this.notification = new Notification('Incoming Request', options)
      } else if (Notification.permission === 'denied') {
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            this.notification = new Notification('Incoming Request', options)
          }
        })
      }
    },
    clearSetInterval: function () {
      if (this.newUserSoundAlerts) {
        clearInterval(this.newUserSoundAlerts)
        // this.newUserSoundAlerts = null
      }
    },
    removeSnackbarWithSameId (elementId) {
      let el = document.getElementById(elementId)
      if (el) {
        removeElement(el)
      }
    },
    soundNotification: function () {
      this.clearSetInterval()
      soundAlerts.create('newuser')
      this.newUserSoundAlerts = setInterval(() => {
        soundAlerts.create('newuser')
        localforage.getItem('audits', function (err, data) {
          if (err === null) {
            data.push({type: 'notification', notification_type: 'voice', created_at: new Date().toString()})
            localforage.setItem('audits', data)
          }
        })
      }, 4000)
    },
    getIncomingRequestText: function (request) {
      let text = `Patient ${request.customer_name} is waiting`
      localforage.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({type: 'notification', notification_type: 'text', customer_name: request.customer_name, created_at: new Date().toString()})
          localforage.setItem('audits', data)
        }
      })
      if (request.isFamilyDoctor) {
        text = `Your patient ${request.customer_name} is waiting`
      }
      return text
    },
    showSnackbar: function (request) {
      this.requestSnackbar = this.$snackbar.open({
        duration: 60000,
        message: this.getIncomingRequestText(request),
        type: 'is-info',
        request: request,
        position: 'is-bottom-left',
        actionText: 'Accept',
        queue: false,
        elementId: request.customer_id,
        onAction: () => {
          this.accept(request)
        }
      })
      localforage.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({type: 'snackbar', action: 'accept', customerId: request.customer_id, created_at: new Date().toString()})
          localforage.setItem('audits', data)
        }
      })
    },
    showMissedSnackbar: function (request) {
      let text = `You missed a consultation from your patient ${request.customer_name}`
      this.missedSnackbar = this.$snackbar.open({
        message: text,
        type: 'is-query',
        request: request,
        position: 'is-bottom-left',
        actionText: 'Respond Back',
        queue: true,
        indefinite: true,
        elementId: request.customer_id,
        onAction: () => {
          this.acceptQuery(request)
        }
      })
      localforage.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({type: 'snackbar', action: 'missed_consultation', customerId: request.customer_id, created_at: new Date().toString()})
          localforage.setItem('audits', data)
        }
      })
    },
    showCancelledSnackbar: function (request) {
      let text = `Patient ${request.customer_name} has cancelled the consultation.`
      if (request.isFamilyDoctor) {
        text = `Your patient ${request.customer_name} has cancelled the consultation.`
      }
      this.$snackbar.open({
        duration: 5000,
        message: text,
        request: request,
        type: 'is-info',
        position: 'is-bottom-left',
        queue: false,
        elementId: request.customer_id
      })
      localforage.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({type: 'snackbar', action: 'patient_cancelled', customerId: request.customer_id, created_at: new Date().toString()})
          localforage.setItem('audits', data)
        }
      })
    },
    showOtherAcceptedSnackbar: function (request) {
      this.$snackbar.open({
        duration: 5000,
        message: request.message,
        request: request,
        type: 'is-info',
        position: 'is-bottom-left',
        queue: false,
        elementId: request.customer_id
      })
      localforage.getItem('audits', function (err, data) {
        if (err === null) {
          data.push({type: 'snackbar', action: 'other_accepted', customerId: request.customer_id, created_at: new Date().toString()})
          localforage.setItem('audits', data)
        }
      })
    },
    closeReloadOverlay: function () {
      this.isReloaded = false
      this.mutedAudio()
    },
    accept: function (request) {
      this.$store.dispatch('consultationRequest/acceptConsultationRequest', request)
    },
    acceptQuery: function (request) {
      this.$store.dispatch('consultationRequest/acceptQueriedConsultationRequest', request)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue